var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-button"},[_c('a',{attrs:{"href":_vm.href}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon,"size":_vm.size}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }